import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@cmps/ng-bootstrap';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonGroupModule,
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsMenuModule,
    CmpsRadioModule,
    CmpsSnackBarModule,
} from '@cmps/ng-uikit';

import { CoachingCanDeactivateService } from '../coaching-base/coaching-can-deactivate.service';
import { CmpsNoteModule } from '../coaching-note/notes.module';
import { CmpsCoachingTagsModule } from '../coaching-tags/coaching-tags.module';
import { CmpCoachingBlButtonModule } from '../coaching/behaviour-library';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsDateTimePickerModule } from '../common/component/datetime-picker';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';

import { TranslationIdMap } from './coaching-observation.i18n';
import { CmpsFormBuilder } from './experimental.form';
import { ExperimentalNgGridModule } from './experimental.grid';
import { ObservationCommitDialogComponent } from './observation-commit-dialog/observation-commit-dialog.component';
import { ObservationControllerComponent } from './observation-controller/controller.observation.component';
import { ObservationMandatoryFieldsDialogComponent } from './observation-dialog-mandatory-fields/observation-dialog-mandatory-fields.component';
import { InteractionObservationComponent } from './observation-interaction/interaction.observation.component';
import { InteractionsObservationComponent } from './observation-interactions/interactions.observation.component';
import { KpiSetObservationComponent } from './observation-kpi-set/kpi-set.observation.component';
import { ObservationNavigatorComponent } from './observation-navigator/navigator.observation.component';
import { ObservationPopUpComponent } from './observation-pop-up/observation-pop-up.component';
import { ObservationReviewComponent } from './observation-review/observation-review.component';
import { ScoreObservationComponent } from './observation-score/score.observation.component';
import { ScoresObservationComponent } from './observation-scores/scores.observation.component';
import { CmpsObservationStatusModule } from './observation-status/observation-status.module';
import { ObservationFocusSummary } from './observation-tag-group/observation.focus.summary.component/observation.focus.summary.component';
import { TagGroupObservationComponent } from './observation-tag-group/tag-group.observation.component';
import { TagGroupsObservationComponent } from './observation-tag-groups/tag-groups.observation.component';
import { ObservationComponent } from './observation/observation.component';
import { ObservationService } from './observation/observation.service';
import { overrideFormArray } from './override';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbDatepickerModule,
        SelectModule,
        CmpsButtonModule,
        CmpsIconModule,
        CmpsMenuModule,
        CmpsCommonModule,
        CmpsLazyI18nModule,
        CmpsNoteModule,
        CmpsCoachingTagsModule,
        ExperimentalNgGridModule,
        CmpsObservationStatusModule,
        CmpsDateTimePickerModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsDialogModule,
        CmpsRadioModule,
        CmpsButtonGroupModule,
        CmpsSnackBarModule,
        CmpCoachingBlButtonModule,
    ],
    declarations: [
        InteractionsObservationComponent,
        ObservationComponent,
        TagGroupObservationComponent,
        TagGroupsObservationComponent,
        InteractionObservationComponent,
        ScoresObservationComponent,
        ScoreObservationComponent,
        ObservationReviewComponent,
        KpiSetObservationComponent,
        ObservationControllerComponent,
        ObservationNavigatorComponent,
        ObservationPopUpComponent,
        ObservationFocusSummary,
        ObservationCommitDialogComponent,
        ObservationMandatoryFieldsDialogComponent,
    ],
    exports: [
        ObservationCommitDialogComponent,
        ObservationComponent,
        ObservationFocusSummary,
        ObservationMandatoryFieldsDialogComponent,
    ],
    providers: [CmpsFormBuilder, CoachingCanDeactivateService],
})
export class CmpsObservationModule {
    static forRoot(): ModuleWithProviders<CmpsObservationModule> {
        return {
            ngModule: CmpsObservationModule,
            providers: [ObservationService],
        };
    }
}

overrideFormArray();
